var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { CaptainComplaintsService } from '../../captain-complaints-by-customer.service';
import { Router } from '@angular/router';
import { Pagination, Table, TableData, TableDataTypes } from 'src/app/shared/types';
var CaptainComplaintsByCustomerComponent = /** @class */ (function () {
    function CaptainComplaintsByCustomerComponent(captainComplaintsService, router) {
        this.captainComplaintsService = captainComplaintsService;
        this.router = router;
        this.toggleHeaders = new EventEmitter();
        this.dataLoaded = false;
    }
    CaptainComplaintsByCustomerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.declareTable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CaptainComplaintsByCustomerComponent.prototype.declareTable = function (pageNumber) {
        if (pageNumber === void 0) { pageNumber = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.captainComplaintsByCustomer = new Table({
                            // tslint:disable-next-line:max-line-length
                            toggleableHeaders: this.captainDetailsToggleableHeaders,
                            headers: {
                                complaint: 'Complaint',
                                complaintsToday: 'Complaints Today',
                                complaintsLast3Days: 'Complaints Last 3 Days',
                                complaintsLast7Days: 'Complaints Last 7 Days',
                                complaintsLast15Days: 'Complaints Last 15 Days',
                                complaintsLast30Days: 'Complaints Last 30 Days',
                                day: 'Created Date',
                            },
                            pagination: new Pagination(pageNumber, 10),
                            selectedHeader: 5,
                            defaultError: 'No Complaints Found',
                            onRefresh: function () {
                                _this.captainComplaintsByCustomer = null;
                                _this.ngOnInit();
                            },
                            data: []
                        });
                        return [4 /*yield*/, this.getCaptainComplaintsByCustomer()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CaptainComplaintsByCustomerComponent.prototype.getCaptainComplaintsByCustomer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dataLoaded = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.captainComplaintsService.fetchComplaintsByCustomer(this.captainId).toPromise()];
                    case 2:
                        response = _a.sent();
                        this.dataLoaded = true;
                        if (response && response.data.found) {
                            this.captainComplaintsByCustomer.data = this.formatCustomerComplaints(response.data.complaints);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error while fetching complaints for customer');
                        console.error(error_1);
                        this.dataLoaded = true;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CaptainComplaintsByCustomerComponent.prototype.formatCustomerComplaints = function (customerComplaints) {
        var _this = this;
        if (customerComplaints === void 0) { customerComplaints = []; }
        var formattedComplaints = [];
        customerComplaints.map(function (item) {
            var complaint = {
                complaint: _this.createTableData(item.subReason || ''),
                complaintsToday: _this.createTableData(item.complaintsToday || ''),
                complaintsLast3Days: _this.createTableData(item.complaintsLast3Days || ''),
                complaintsLast7Days: _this.createTableData(item.complaintsLast7Days || ''),
                complaintsLast15Days: _this.createTableData(item.complaintsLast15Days || ''),
                complaintsLast30Days: _this.createTableData(item.complaintsLast30Days || ''),
                day: _this.createTableData(item.day),
            };
            formattedComplaints.push(complaint);
        });
        this.captainComplaintsByCustomer.data = formattedComplaints;
        return formattedComplaints;
    };
    CaptainComplaintsByCustomerComponent.prototype.createTableData = function (value, className, type, flag, hoverData) {
        if (flag === void 0) { flag = false; }
        return new TableData({
            data: value,
            type: type ? type : TableDataTypes.DATA,
            flag: flag,
            hoverData: hoverData ? hoverData : null,
            className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
        });
    };
    CaptainComplaintsByCustomerComponent.prototype.changeInHeader = function (header) {
        this.toggleHeaders.emit(header);
    };
    CaptainComplaintsByCustomerComponent.prototype.onPaginationChange = function (event) {
        this.getCaptainComplaintsByCustomer();
    };
    return CaptainComplaintsByCustomerComponent;
}());
export { CaptainComplaintsByCustomerComponent };
